// extracted by mini-css-extract-plugin
export default {"videoContainer":"VideoPlayer-module__videoContainer_tgf7W","videoWrapper":"VideoPlayer-module__videoWrapper_zYoZW","toggleContainer":"VideoPlayer-module__toggleContainer_K0gJR"};